module.exports = __webpack_public_path__ + "static/nucleus-04f24b35b170403bcb22bc32fb151430.png";